const actions = {
  assets({dispatch, commit, getters, rootGetters}, params) {
    return rootGetters['session/ajax'].get('/asset_associations', { params }).then(response => {
      commit('attachments/setAttachments', response.data.attachments, { root: true });
      commit('flashcards/setFlashcards', { records: response.data.flashcards }, { root: true });
      commit('topics/setTopics', response.data.topics, { root: true });
      return response.data;
    });
  },
};

export default {
  namespaced: true,
  actions,
};
